import React, { useState } from 'react';
import { ShoppingCart, CreditCard, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { paymentService } from '../services/paymentService';
import { AgeVerificationModal } from './AgeVerificationModal';
import { useToast } from '../hooks/use-toast';

export const PaymentButton = ({ 
  packageId, 
  productName, 
  price, 
  requiresAgeVerification = false,
  variant = 'default',
  size = 'default',
  className = '',
  children 
}) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [showAgeModal, setShowAgeModal] = useState(false);

  const handlePayment = async () => {
    // Show age verification modal if required
    if (requiresAgeVerification) {
      setShowAgeModal(true);
      return;
    }
    
    // Otherwise proceed directly to payment
    await initiateCheckout();
  };

  const handleAgeVerified = () => {
    initiateCheckout({ age_verified: true });
  };

  const initiateCheckout = async (metadata = {}) => {
    setIsLoading(true);
    
    try {
      // Create checkout session
      const session = await paymentService.createCheckoutSession(
        packageId,
        null, // user_email - can be added later
        {
          product_name: productName,
          ...metadata
        }
      );

      // Redirect to Stripe Checkout
      window.location.href = session.url;
      
    } catch (error) {
      console.error('Payment error:', error);
      toast({
        title: 'Payment Error',
        description: error.response?.data?.detail || 'Failed to initiate payment. Please try again.',
        variant: 'destructive'
      });
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        onClick={handlePayment}
        disabled={isLoading}
        variant={variant}
        size={size}
        className={className}
      >
        {isLoading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Processing...
          </>
        ) : (
          children || (
            <>
              <CreditCard className="w-4 h-4 mr-2" />
              Buy Now - ${price}
            </>
          )
        )}
      </Button>

      {requiresAgeVerification && (
        <AgeVerificationModal
          isOpen={showAgeModal}
          onClose={() => setShowAgeModal(false)}
          onConfirm={handleAgeVerified}
          productName={productName}
        />
      )}
    </>
  );
};
